import { render, staticRenderFns } from "./Winners.vue?vue&type=template&id=8e3ff086&scoped=true&"
import script from "./Winners.vue?vue&type=script&lang=js&"
export * from "./Winners.vue?vue&type=script&lang=js&"
import style0 from "./Winners.vue?vue&type=style&index=0&id=8e3ff086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3ff086",
  null
  
)

export default component.exports